import React, { useEffect, useState } from 'react';
import { APIProvider, Map } from '@vis.gl/react-google-maps';

interface ProjectMapProps {
  lat: number;
  lng: number;
}

const ProjectMap: React.FC<ProjectMapProps> = ({ lat, lng }) => {
  const mapCenter = { lat, lng };

  const mapsEnabled = process.env.REACT_APP_GOOGLE_MAPS_ENABLED === 'true';
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
  const mapId = process.env.REACT_APP_GOOGLE_MAPS_MAP_ID || '';

  const [map, setMap] = useState<google.maps.Map | null>(null);
  const [isZoomInitialized, setIsZoomInitialized] = useState(false); // Track if zoom is set

  useEffect(() => {
    const addAdvancedMarker = async () => {
      if (!map) return;

      const { AdvancedMarkerElement, PinElement } = (await google.maps.importLibrary('marker')) as {
        AdvancedMarkerElement: typeof google.maps.marker.AdvancedMarkerElement;
        PinElement: typeof google.maps.marker.PinElement;
      };

      // Create a custom pin using PinElement
      const pin = new PinElement({
        background: '#d32f2f', // Red pin background
        borderColor: '#FFFFFF', // White border
        glyphColor: '#FFFFFF', // White glyph text
        scale: 1.2, // Scale for the pin size
        glyph: 'O', // Optional glyph (e.g., a letter or symbol)
      });

      // Create the AdvancedMarkerElement
      new AdvancedMarkerElement({
        map,
        position: mapCenter,
        content: pin.element,
      });
    };

    addAdvancedMarker();
  }, [map, mapCenter]);

  if (!mapsEnabled) {
    return <p style={{ marginLeft: '20px', color: '#555', fontSize: '16px', fontStyle: 'italic' }}>Maps are disabled.</p>;
  }

  if (!googleMapsApiKey) {
    return <div>Google Maps API key is missing.</div>;
  }

  return (
    <APIProvider apiKey={googleMapsApiKey}>
      <div style={containerStyle}>
        <Map
          mapId={mapId}
          style={{ width: '100%', height: '100%' }}
          onIdle={event => {
            const mapInstance = event.map;
            if (mapInstance instanceof google.maps.Map) {
              setMap(mapInstance);
              if (!isZoomInitialized) {
                mapInstance.setCenter(mapCenter);
                mapInstance.setZoom(13); // Set initial zoom
                setIsZoomInitialized(true); // Mark zoom as initialized
              }
            }
          }}
        />
      </div>
    </APIProvider>
  );
};

const containerStyle = {
  width: '100%',
  height: '400px',
};

export default ProjectMap;
